exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn[data-v-52ea2924] {\n    width: 160px;\n}\n", ""]);

// exports
